<section
  class="common-container flex flex-wrap p-4 mb-4 justify-content-center">
  <div class="flex mb-4">
    <h2
      class="text-2x font-normal text-center"
      i18n="coverage-summary.text.international-benefit">
      Beneficio internacional de asistencia para casos de accidentes de buceo
    </h2>
  </div>

  <div class="grid">
    <div class="col-12 sm:col-6 flex align-items-center">
      <div>
        <img src="assets/img/flag/ES.jpg" alt="ES" width="40px" cl ass="mr-3" />
      </div>
      <div>
        Para descargar el resumen de coberturas por favor, haga
        <a
          color="blue.400"
          href="assets/media/coberturas/SCUBAMEDIC-ESPANOL.pdf"
          target="_blank">
          click aquí
        </a>
        .
      </div>
    </div>
    <div class="col-12 sm:col-6 flex align-items-center">
      <div>
        <img src="assets/img/flag/CA.jpg" alt="CA" width="40px" class="mr-3" />
      </div>

      <div>
        Per descarregar el resum de la seva cobertura de l'assegurança si us
        plau
        <a
          color="blue.400"
          href="assets/media/coberturas/SCUBAMEDIC-Catalan.pdf"
          target="_blank">
          cliqueu aquí
        </a>
        .
      </div>
    </div>
    <div class="col-12 sm:col-6 flex align-items-center">
      <img src="assets/img/flag/EN.jpg" alt="EN" width="40px" class="mr-3" />
      <div>
        To download a resume of the Insurance coverage, please
        <a
          color="blue.400"
          href="assets/media/coberturas/SCUBAMEDIC-Ingles.pdf"
          target="_blank">
          click here
        </a>
        .
      </div>
    </div>

    <div class="col-12 sm:col-6 flex align-items-center">
      <img src="assets/img/flag/DE.jpg" alt="DE" width="40px" class="mr-3" />
      <div>
        Um die Zusammenfassung des Versicherungsschutzes herunterzuladen
        <a
          class="blue.400"
          href="assets/media/coberturas/SCUBAMEDIC-Aleman.pdf"
          target="_blank">
          klicken Sie bitte hier
        </a>
        .
      </div>
    </div>

    <div class="col-12 sm:col-6 flex align-items-center">
      <img src="assets/img/flag/FR.jpg" alt="FR" width="40px" class="mr-3" />
      <div>
        Pour télécharger le résumé de la couverture d'assurance,
        <a
          class="blue.400"
          href="assets/media/coberturas/SCUBAMEDIC-Frances.pdf"
          target="_blank">
          cliquez ici </a
        >.
      </div>
    </div>
  </div>
</section>
